const numberFormats = {
    'en-US': {
        currency: {
            style: 'currency',
            currency: 'USD'
        }
    },
    'en-GB': {
        currency: {
            style: 'currency',
            currency: 'GBP'
        }
    },
    'de-DE': {
        currency: {
            style: 'currency',
            currency: 'EUR'
        }
    },
    'fr-FR': {
        currency: {
            style: 'currency',
            currency: 'EUR'

        }
    },
    'nl-NL': {
        currency: {
            style: 'currency',
            currency: 'EUR'
        }
    },
    'es-ES': {
        currency: {
            style: 'currency',
            currency: 'EUR'

        }
    },
    'pl-PL': {
        currency: {
            style: 'currency',
            currency: 'PLN'

        }
    },
    'en-IE': {
        currency: {
            style: 'currency',
            currency: 'EUR'

        }
    },
    'en-AU': {
        currency: {
            style: 'currency',
            currency: 'AUD'

        }
    },
    'en-NZ': {
        currency: {
            style: 'currency',
            currency: 'NZD'

        }
    },
    'en-CA': {
        currency: {
            style: 'currency',
            currency: 'CAD'

        }
    },
    'en-SA': {
        currency: {
            style: 'currency',
            currency: 'ZAR'

        }
    }
};

Object.keys(numberFormats)
    .forEach(k => numberFormats[k].paddedInteger = {
        minimumIntegerDigits: 2
    });

export default numberFormats;
